export const XerjoffITPrivacyPolicy = () => (
  <div className="privacy-policy">
    <h2>INFORMATIVA PRIVACY -- RACCOLTA DATI IN BOUTIQUE</h2>
    <p>
      <strong>Versione:</strong> 1.0 | <strong>Data:</strong> 05 March 2026
    </p>

    <section>
      <p>
        La presente informativa riguarda la raccolta dei dati all'interno delle
        boutique a marchio Xerjoff mediante dispositivi digitali (tablet) e
        relativi sistemi CRM.
      </p>
      <h2>1. Titolare del trattamento</h2>
      <p>
        Il Titolare del trattamento dei dati personali raccolti in boutique è
        XERJOFF GROUP S.p.A. con sede legale in Via Tenivelli 29, 10024
        Moncalieri (TO), Italia, REA TO 106649, C.F./P. IVA 09547650011. La sede
        operativa è in Via Torino 15, 10044 Pianezza (TO), Italia. Il Titolare
        può essere contattato all'indirizzo mail{' '}
        <a href="mailto:gdpr@xerjoff.com">gdpr@xerjoff.com</a> e PEC{' '}
        <a href="mailto:pec@pec.xerjoff.com">pec@pec.xerjoff.com</a>.
      </p>
      <p>
        Xerjoff Group S.p.A. ha nominato il Responsabile della Protezione dei
        Dati (DPO), contattabile all'indirizzo e-mail{' '}
        <a href="mailto:dpo@xerjoff.com">dpo@xerjoff.com</a>.
      </p>
    </section>

    <section>
      <h2>2. Tipologie di dati trattati</h2>
      <p>
        Possono essere raccolti e trattati i seguenti dati personali: nome e
        cognome, e-mail, numero di telefono, data di nascita, preferenze e
        interessi su prodotti, storico acquisti, dati relativi alle interazioni
        con il personale di vendita, eventuali informazioni ulteriori fornite
        volontariamente dall'interessato. Non vengono raccolti dati di minori.
        Non sono richiesti né devono essere conferiti dati appartenenti a
        categorie particolari di dati personali (art. 9 GDPR) né dati relativi a
        condanne penali e reati (art. 10 GDPR).
      </p>
    </section>

    <section>
      <h2>3. Modalità di raccolta</h2>
      <p>
        I dati sono raccolti: (i) direttamente dall'interessato tramite tablet
        in boutique; (ii) tramite inserimento da parte del personale su richiesta
        del cliente; (iii) mediante integrazione con sistemi ufficiali del brand
        per la gestione del profilo cliente.
      </p>
      <p>
        Prima della registrazione, l'interessato prende visione della presente
        informativa e può prestare consensi separati per marketing e
        profilazione.
      </p>
    </section>

    <section>
      <h2>4. Finalità e basi giuridiche</h2>
      <p>
        <strong>a) Registrazione e gestione della relazione:</strong> per
        registrare il cliente nei sistemi e gestire richieste informative. Base
        giuridica: art. 6(1)(b) GDPR.
      </p>
      <p>
        <strong>b) Marketing diretto:</strong> invio di comunicazioni
        commerciali, inviti ad eventi, novità e offerte tramite e-mail, SMS o
        altri canali digitali. Base giuridica: consenso (art. 6(1)(a) GDPR).
      </p>
      <p>
        <strong>c) Profilazione:</strong> analisi di preferenze e comportamenti
        di acquisto/contatto per personalizzare comunicazioni e offerte. Base
        giuridica: consenso (art. 6(1)(a) GDPR).
      </p>
      <p>
        Il consenso per marketing e profilazione è facoltativo, specifico e
        separato; può essere revocato in ogni momento dall'interessato.
      </p>
    </section>

    <section>
      <h2>5. Natura del conferimento</h2>
      <p>
        Il conferimento dei dati per la registrazione può essere necessario per
        fruire di specifiche iniziative (ad es. ricevere informazioni richieste).
      </p>
      <p>
        Il conferimento dei dati per marketing e profilazione è facoltativo.
        L'eventuale mancato consenso non incide sulla possibilità di acquistare
        prodotti in boutique.
      </p>
    </section>

    <section>
      <h2>6. Modalità di trattamento e misure di sicurezza</h2>
      <p>
        Il trattamento avviene con strumenti elettronici e informatici (tablet,
        sistemi CRM e piattaforme di gestione) nel rispetto dei principi di
        correttezza, liceità, trasparenza e minimizzazione.
      </p>
      <p>
        Sono adottate misure tecniche e organizzative adeguate a proteggere i
        dati personali.
      </p>
    </section>

    <section>
      <h2>7. Destinatari dei dati</h2>
      <p>
        I dati personali possono essere trattati da personale autorizzato del
        Titolare.
      </p>
      <p>
        I dati possono essere comunicati a soggetti che trattano dati per conto
        del Titolare, quali Responsabili del trattamento (art. 28 GDPR), tra cui:
        fornitori IT, hosting/cloud, CRM e marketing automation, servizi di
        invio e-mail/SMS, assistenza e manutenzione sistemi.
      </p>
      <p>
        Tra tali soggetti rientra Dylog Italia S.p.A., quale fornitore del
        software di acquisizione/gestione dati utilizzato nelle boutique.
      </p>
      <p>
        Laddove imposto da legge o ordine dell'Autorità, i dati potranno essere
        comunicati a soggetti pubblici competenti.
      </p>
    </section>

    <section>
      <h2>8. Trasferimenti verso Paesi terzi</h2>
      <p>
        Qualora alcuni fornitori si trovino al di fuori dello Spazio Economico
        Europeo, i trasferimenti avverranno nel rispetto del GDPR, mediante
        decisioni di adeguatezza o garanzie appropriate (es. Clausole
        Contrattuali Standard).
      </p>
    </section>

    <section>
      <h2>9. Periodo di conservazione</h2>
      <p>
        I dati trattati per finalità di marketing e/o profilazione sono
        conservati fino a 7 anni dall'ultima interazione significativa con il
        brand o fino a revoca del consenso, salvo necessità di conservazione più
        lunga per obblighi di legge o per la tutela dei diritti del Titolare.
      </p>
      <p>
        I dati necessari per adempimenti amministrativi/contabili (se
        applicabili) saranno conservati per i tempi previsti dalla normativa.
      </p>
    </section>

    <section>
      <h2>10. Diritti dell'interessato</h2>
      <p>
        L'interessato può esercitare i diritti di cui agli artt. 15-22 GDPR
        (accesso, rettifica, cancellazione, limitazione, portabilità,
        opposizione) e revocare il consenso in qualsiasi momento.
      </p>
      <p>
        Per esercitare i diritti:{' '}
        <a href="mailto:gdpr@xerjoff.com">gdpr@xerjoff.com</a> o{' '}
        <a href="mailto:dpo@xerjoff.com">dpo@xerjoff.com</a>.
      </p>
    </section>

    <section>
      <h2>11. Reclamo all'Autorità di controllo</h2>
      <p>
        Qualora Lei ritenga che il trattamento dei Suoi dati personali violi il
        GDPR, Lei ha diritto di proporre reclamo al Garante per la protezione
        dei dati personali o all'Autorità di controllo competente nel Suo Stato
        membro.
      </p>
    </section>

    <section>
      <h2>12. Aggiornamenti</h2>
      <p>
        La presente informativa può essere aggiornata. La versione più recente
        è resa disponibile in boutique e/o sui canali ufficiali del brand.
      </p>
    </section>
  </div>
);